export enum DISALLOWED_WORD_PERMISSIONS {
  DISALLOWED_WORD_VIEW = 'REVIEW_DISALLOWEDWORDSVIEW',
  DISALLOWED_WORD_WRITE = 'REVIEW_DISALLOWEDWORDSWRITE',
}
